import type { MessageDescriptor, IntlShape } from 'react-intl';

export const getFormattetMessage = (
  messagesObj: { [key: string]: MessageDescriptor },
  messageId: string,
  intl: IntlShape,
): string => {
  const [, message] = Object.entries(messagesObj).find(([, msg]) => msg.id === messageId) || [];
  return message ? intl.formatMessage(message) : messageId;
};
